import React from 'react';
import classNames from 'classnames';
import DropdownOnHover from 'components/DropdownOnHover';
import ChevrondownIcon from 'icons/Chevrondown.icon';
import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { getResolveUrl } from 'utils';
import { IconProp } from 'models/Icon';

import './DropdownsOnHoverInstance.styles.scss';

type DropdownsOnHoverInstanceLink = {
  href: string;
  label: string;
  icon?: IconProp;
};

type DropdownsOnHoverInstanceProps = {
  className?: string;
  text: string;
  links: DropdownsOnHoverInstanceLink[];
  icon?: IconProp;
  onTriggerAction?: () => void;
  asExternal?: boolean;
};

const DropdownsOnHoverInstance: React.FC<DropdownsOnHoverInstanceProps> = (
  props,
) => {
  const {
    className,
    text,
    links,
    asExternal = false,
    icon: Icon,
    onTriggerAction,
  } = props;

  const classes = classNames('dropdowns-on-hover-instance', className);

  const { t } = useTranslation();

  return (
    <DropdownOnHover
      className={classes}
      onTriggerAction={onTriggerAction}
      triggerContent={
        <>
          {Icon && <Icon />}
          <span>{text}</span>
          <ChevrondownIcon className="chevron-icon" />
        </>
      }
    >
      <ul>
        {links.map(({ href, label, icon: Icon }) => (
          <li key={href}>
            {asExternal ? (
              <a href={getResolveUrl(href)} aria-label={t(label)}>
                {Icon && <Icon />}
                {t(label)}
              </a>
            ) : (
              <NavLink
                to={href}
                className={({ isActive }) => {
                  if (isActive) return 'active';
                }}
              >
                {Icon && <Icon />}
                {t(label)}
              </NavLink>
            )}
          </li>
        ))}
      </ul>
    </DropdownOnHover>
  );
};

export default DropdownsOnHoverInstance;
